<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
                </Col>
                <Col span="8">
                    <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
                </Col>
                <Col span="8">
                    <div>订单总额：￥{{ orderInfo.recoveryOrder.totalAmount ? orderInfo.recoveryOrder.totalAmount : '-' }}
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                        订单状态：
                        <template v-if="orderInfo.recoveryOrder.orderState == 1">未接单</template>
                        <template v-if="orderInfo.recoveryOrder.orderState == 2">已接单</template>
                        <template v-if="orderInfo.recoveryOrder.orderState == 3">已完成</template>
                        <template v-if="orderInfo.recoveryOrder.orderState == 4">已取消</template>
                    </div>
                </Col>
                <Col span="8">
                    <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
                </Col>
              <Col span="8">
                <div>
                  回收员姓名：{{
                    orderInfo.recoveryOrder.recoveryUserName ? orderInfo.recoveryOrder.recoveryUserName : '-'
                  }}
                </div>
              </Col>
            </Row>
            <Divider orientation="left">进行派单</Divider>
            <Row :gutter="16">
                <div>
                  回收人员：
                  <Select v-model="recoveryUserId" style="width:200px">
                    <Option v-for="(item, index) in userList" :value="item.value" :key="index">{{ item.label }}</Option>
                  </Select>
                </div>
            </Row>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="dispatchOrder()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">保存</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '派单',
            images: [],
            showImage: false,
            userList: [],
            recoveryUserId: '',
            recoveryOrderId: '',
            params: {
              page: 1,
              rows: 20,
              isDisable: 0,
            }
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.findList();
            this.isShowModal = true;
            this.getInfo(row);
        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                console.log(res);
                this.recoveryOrderId = row.recoveryOrderId
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        // 保存派单
        dispatchOrder() {
          this.axios.post('/recoveryOrder/dispatchOrder', {'recoveryUserId': this.recoveryUserId, 'recoveryOrderId': this.recoveryOrderId}).then(res => {
            if (res.status == 200) {
              this.$emit('changeDate');
              this.$Message.success('操作成功.');
              this.hide('formValidate');
            }
            if(res.status == 201){
              this.$Message.error(res.msg);
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '派单接口报错',
                duration: 0
              });
            }
          })
        },
        // 回收员-列表查询
        findList() {
          this.axios.post('/recoveryUser/findList', this.params).then(res => {
            if (res.status == 200) {
              this.total = res.data.total;
              this.data = res.data.rows;
              console.log('data,,,,', this.data)
              if (this.data) {
                this.userList = []
                this.data.forEach(v => {
                  let object = {
                    value: v.recoveryUserId,
                    label: v.realName
                  }
                  this.userList.push(object)
                })
              }
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '查询回收员列表接口报错',
                duration: 0
              });
            }
          })
        },
    }
}
</script>

<style scoped lang="less">
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}

</style>